/** Public site URL for canonical links, sitemap hints, and structured data. Override via REACT_APP_SITE_URL. */
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://notrack.in').replace(/\/$/, '');

export const SITE_NAME = 'Notrack';

/**
 * Contact email for legal, privacy, and grievance notices.
 * Set REACT_APP_CONTACT_EMAIL in `.env.local` for production.
 */
export const SITE_CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || 'hello@notrack.in';

/**
 * Grievance officer name (DPDP Act, India). Set REACT_APP_GRIEVANCE_OFFICER_NAME when you appoint a person.
 */
export const SITE_GRIEVANCE_OFFICER_NAME =
  process.env.REACT_APP_GRIEVANCE_OFFICER_NAME || 'Grievance Officer';

/** Exclusive jurisdiction for Terms (courts). Adjust if your entity is registered elsewhere. */
export const SITE_LEGAL_JURISDICTION = 'Hyderabad, Telangana, India';

/** Last updated date shown on legal pages (ISO-style display string). */
export const SITE_LEGAL_LAST_UPDATED = 'April 9, 2026';

/** Primary HTML/document language */
export const SITE_DEFAULT_LANG = 'en';

/** Open Graph locale (India-focused English). */
export const SITE_OG_LOCALE = 'en_IN';

/**
 * Absolute URL for default share image (1200×630 recommended). Falls back to logo in /public.
 * Override with REACT_APP_OG_IMAGE_URL for a dedicated OG asset.
 */
export function getDefaultOgImageUrl() {
  const absolute = process.env.REACT_APP_OG_IMAGE_URL;
  if (absolute) return absolute.replace(/\/$/, '');
  const publicBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${SITE_URL}${publicBase}/black.png`;
}

/** Build absolute canonical URL from a pathname (e.g. `/blog/foo`). */
export function toCanonicalUrl(pathname) {
  const path = pathname === '/' ? '/' : pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${SITE_URL}${path}`;
}
